/**
 * Google Analytics 4 - Event tracking do site de marketing.
 *
 * Todos os eventos carregam `role` ('athlete' | 'coach') para que o funil de
 * treinador possa ser lido separadamente do de atleta no GA4.
 */

const isBrowser = () => typeof window !== 'undefined';

export const trackEvent = (eventName, params = {}) => {
  if (!isBrowser() || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
};

export const trackPageView = ({ role, pageTitle }) => {
  if (!isBrowser()) return;
  trackEvent('page_view', {
    role,
    page_title: pageTitle,
    page_location: window.location.href,
    page_path: window.location.pathname,
  });
};

export const trackCTAClick = ({ role, ctaId, location }) => {
  trackEvent('click_cta', { role, cta_id: ctaId, location });
};

/**
 * Sucesso na gravação do e-mail na waitlist. Envia apenas o domínio do e-mail
 * para não trafegar dado pessoal para o GA.
 */
export const trackWaitlistSubmit = ({ role, source, email, language }) => {
  trackEvent('waitlist_submit', {
    role,
    source,
    language,
    email_domain: typeof email === 'string' ? email.split('@')[1] : undefined,
  });
};

export const trackWaitlistError = ({ role, source, reason }) => {
  trackEvent('waitlist_error', { role, source, reason });
};
